import type { InjectionKey } from 'vue';

import type { RadioGroupInjection } from './RadioGroup.types';

export const RADIO_GROUP_INJECTION = {
  key: Symbol('RADIO_GROUP_INJECTION_KEY') as InjectionKey<RadioGroupInjection>,
};
